import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {NEVER, Observable} from 'rxjs';
import {finalize, repeat, retry, takeUntil} from 'rxjs/operators';
import {retryStrategyWithIncreasedDelay} from '../common/rxjs/retry-strategy-with-increased-delay';
import {destroy$} from '../components/destroyable';
import {AppConfigService} from './config.service';

const ECHO_REQUEST_INTERVAL = 4 * 60 * 1000; // 4 minutes

@Injectable()
export class EchoService {

    public readonly destroy$ = destroy$();

    private isEchoInitialized: boolean = false;

    private readonly httpClient = inject(HttpClient);
    private readonly appConfigService = inject(AppConfigService);

    private readonly echoUrl: string = this.appConfigService.isBoEnv()
        ? this.appConfigService.api['backofficeEcho']
        : this.appConfigService.api['echo'];

    public initializeSendingEchoRequests(destroy$?: Observable<void>): void {
        if (!this.isEchoInitialized) {
            this.isEchoInitialized = true;

            this.sendEchoRequest().pipe(
                retry({delay: retryStrategyWithIncreasedDelay()}),
                repeat({delay: ECHO_REQUEST_INTERVAL}),
                takeUntil(destroy$ || NEVER),
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isEchoInitialized = false;
                })
            ).subscribe();
        } else {
            console.error('[EchoService] Initialization is called again, when it\'s already initialized.');
        }
    }

    public sendEchoRequest(): Observable<void> {
        return this.httpClient.get<any>(this.echoUrl);
    }

}
